<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_contract"
            role="tab"
          >
            <h5><span class="far fa-pen-nib"></span> Criar Descontos ou Acréscimos por serviço</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_contract" role="tabpanel">
          <CreateDiscountAdditionSaveForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateDiscountAdditionSaveForm from '@/components/discount-addition-services/CreateDiscountAdditionSaveForm';

export default {
  name: 'CreateDiscountAdditionModal',
  components: { CreateDiscountAdditionSaveForm },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showCreateDiscountAddition = null;
    },
  },
};
</script>
